
namespace GeniuzPOS.InventoryReport {

    @Serenity.Decorators.registerClass()
    export class IcReport01Grid extends Serenity.EntityGrid<IcReport01Row, any> {
        protected getColumnsKey() { return IcReport01Columns.columnsKey; }
        protected getDialogType() { return IcReport01Dialog; }
        protected getIdProperty() { return IcReport01Row.idProperty; }
        protected getInsertPermission() { return IcReport01Row.insertPermission; }
        protected getLocalTextPrefix() { return IcReport01Row.localTextPrefix; }
        protected getService() { return IcReport01Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        private getFilterDescriptions(grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.IcReportPdfOptions): any {
            // let request = Q.deepClone(grid.view.params) as Serenity.ListRequest;
            // let columns = Object.keys(options.columnStyles)

            let descriptions: string[] = [];

            let lets = Q.tryFirst(QRreport.QRywcSpecRow.getLookup().items, x => x.Id == 46)

            var b1 = ""
            let b1n : string = lets.SkuCode;
            if (b1n != null) {
                let pos = Product.CsSkuRow.getLookup().itemById[b1n].SkuCode;
                b1 = " ระบุสินค้า:" + b1n + " " + pos

            } else {

                b1 

            }
            var b = ""
            let find : string = lets.CatCode;
            if (find != null) {
                let pos = Product.CsCategoryRow.getLookup().itemById[find].CatName;
                b = b1 + " ระบุหมวดสินค้า:" + find + " " + pos

            } else {

                b = b1

            }
            var c = ""
            let cf : string = lets.SubCat1Code;


            if (cf != null) {
                let cn = Product.CsSubCategory1Row.getLookup().itemById[cf].SubCat1Name;
                c = b + " ระบุหมวดสินค้า2:" + cf + " " + cn

            } else {

                c = b

            }

            var d = ""
            let df : string = lets.SubCat2Code;


            if (df != null) {
                let dn = Product.CsSubCategory2Row.getLookup().itemById[df].SubCat2Name;
                d = c + " ระบุหมวดสินค้า3:" + df + " " + dn

            } else {

                d = c

            }
            var e = ""
            let ef : string = lets.BrandCode;


            if (ef != null) {
                let en = Product.CsBrandRow.getLookup().itemById[ef].BrandName;
                e = d + " ระบุแบรนด์:" + en

            } else {

                e = d

            }
            var f = ""
            let ff : string= lets.StyleId;


            if (ff != null) {
                let fn = Product.CsStyleRow.getLookup().itemById[ff].StyleName;
                f = e + " ระบุแบบ:" + fn

            } else {

                f = e

            }

            var g = ""
            let gf : string= lets.ColorId;
            // let gn = Product.CsColorRow.getLookup().itemById[find].ColorName;

            if (gf != null) {

                g = f + " ระบุสี:" + gf

            } else {

                g = f

            }
            var h = ""
            let hf : string= lets.SizeId;
            // let hn = Product.CsColorRow.getLookup().itemById[find].ColorName;

            if (hf != null) {

                h = g + " ระบุขนาด:" + hf

            } else {

                h = g

            }
            var ii = ""
            let iif : string= lets.TasteId;
            // let hn = Product.CsColorRow.getLookup().itemById[find].ColorName;

            if (iif != null) {

                ii = h + " ระบุกลิ่น/รส:" + iif

            } else {

                ii = h

            }
            var j = ""
            let jf : string= lets.MatTypeId;
            // let hn = Product.CsColorRow.getLookup().itemById[find].ColorName;

            if (jf != null) {

                j = ii + " ระบุวัสดุ:" + jf

            } else {

                j = ii

            }
            var k = ""
            let kf : string= lets.SupplId;
            // let hn = Product.CsColorRow.getLookup().itemById[find].ColorName;

            if (kf != null) {

                k = j + " ระบุผู้จำหน่าย:" + kf

            } else {

                k = j

            }
            var l = ""
            let lf = lets.ConsignFg;
            // let hn = Product.CsColorRow.getLookup().itemById[find].ColorName;

            if (lf != null) {

                if (lf = 0) {
                    l = k + " สินค้าปกติเท่านั้น"
                } else {
                    l = k + " สินค้าฝากขายเท่านั้น"
                }

            } else {

                l = k

            }

            descriptions.push(l);
            return [descriptions, gridColumns];
        }
        // protected createQuickSearchInput() {
        // }

        protected getColumns() {
            var columns = super.getColumns();

            return columns;
        }

        protected usePager() {
            return false;
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });

            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["CatName"]);
        }


        protected markupReady() {
            super.markupReady();

            // expanding all level 0 (Country) and level 1 (City) groups initially
            this.view.expandAllGroups(0);
            // this.view.expandAllGroups(1);
            // this.view.expandAllGroups(2);

        }
        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: IcReport01Service.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            let reportTitle = 'รายงานสินค้าคงเหลือรวมทุกคลัง'

            // Max page width = 277
            let columnStyles: { [dataKey: string]: GeniuzPOS.Common.Helpers.AutoTableStyles } = {
                0: { field: "SkuCode", title: "รหัสสินค้า", cellWidth: 20, },
                1: { field: "SkuDesc", title: "ชื่อ", cellWidth: 60, overflow: 'linebreak', },
                2: { field: "SkuEnDesc", title: "Sku Name", cellWidth: 60, overflow: 'linebreak', },
                3: { field: "QtyOnHand", title: "จำนวน", cellWidth: 15, halign: 'right', aggregate: "sum" },
                4: { field: "StkUnit", title: "หน่วย", cellWidth: 10, overflow: 'linebreak'},
                5: { field: "BrandCode", title: "ยี่ห้อ", cellWidth: 12 },
                6: { field: "StyleId", title: "แบบ", cellWidth: 10 },
                7: { field: "SizeId", title: "ขนาด", cellWidth: 10 },
                8: { field: "ColorId", title: "สี", cellWidth: 8 },
                9: { field: "SupplId", title: "ผู้จำหน่าย", isHidden: true },
                10: { field: "SupplName", title: "ผู้จำหน่าย", cellWidth: 60},
                11: { field: "CatCode", title: "หมวดสินค้า", isHidden: true },
                12: { field: "CatName", title: "หมวดสินค้า", cellWidth: 25 },
                13: { field: "SubCat1Code", title: "หมวดสินค้า-2", isHidden: true },
                14: { field: "SubCat1Name", title: "หมวดสินค้า-2", cellWidth: 25 },
                15: { field: "SubCat2Code", title: "หมวดสินค้า-3", isHidden: true },
                16: { field: "SubCat2Name", title: "หมวดสินค้า-3", cellWidth: 25 },
                          

                
                // 25: { field: "SizeName", title: "ขนาด", isHidden: true },
                17: { field: "TasteId", title: "กลิ่น/รส", isHidden: true },
                // 27: { field: "TasteName", title: "กลิ่น/รส", isHidden: true },
                18: { field: "MatTypeId", title: "วัสดุที่ใช้", isHidden: true },
                
                19: { field: "ConsignFg", title: "สินค้าฝากขาย?", isHidden: true }

            }

            // buttons.push(GeniuzPOS.Common.Helpers.IcReportPdfHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.IcReportPdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),

            //     pageNumbers: true,
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     pageSize:{width:210,height:297},
            //     theme: 'plain',
            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,
            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                 // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));

            // buttons.push(GeniuzPOS.Common.Helpers.IcReportPdfHelper.createToolButton({
            //     grid: this,
            //     onViewSubmit: () => this.onViewSubmit(),
            //     reportTitle: reportTitle,
            //     separator: true,
            //     onCreateFilterDescriptions: (grid: Serenity.DataGrid<any, any>, gridColumns: Slick.Column[], options: GeniuzPOS.Common.Helpers.IcReportPdfOptions) => this.getFilterDescriptions(grid, gridColumns, options),

            //     pageNumbers: true,
            //     autoPrint: true,
            //     output: "dataurlnewwindow",
            //     columnStyles: columnStyles,
            //     // groupHeader: {
            //     //     0: { title: 'หน่วย', startX: 125, width: 70 }
            //     // },
            //     hideGroupColumn: false,
            //     theme: 'plain',

            //     showTableHead: 'everyPage',
            //     isCustomHeader: true,

            //     //reportTitle: "This is report title",
            //     titleTop: 7,
            //     titleFontSize: 12,
            //     fileName: "ThisIsTheFileName",
            //     //pageNumbers: true,
            //     columnTitles: {
            //         'OriginalColumn': 'OCol.',
            //     },
            //     tableOptions: {
            //         columnStyles: {
            //             OriginalColumn: {
            //                 // columnWidth: 25,
            //                 halign: 'right'
            //             }
            //         }
            //     }
            // }));
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/QRreport/QRywcSpec#QRreport.QRywcSpec_icrp01_8/edit/46';
                        return false;
                    },
                }
            );
            return buttons;
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
             opt.groupingPanel = true;
            opt.showFooterRow = true;
            return opt;
        }

        protected createSlickGrid() {
            var grid = super.createSlickGrid();

            

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('QtyOnhand'),
                    // new Slick.Aggregators.Sum('StockCostValue')

                ]
            });
            return grid;
        }
    }
}